export const USERNAME_MAX_LENGTH = 256

// Keep the order and allowed characters aligned with UserCreationService.ValidateUsername.
export function usernameProblem(value) {
  const username = (value ?? '').trim()
  if (!username) return 'usernameRequired'
  if (/\s/u.test(username)) return 'usernameSpaces'
  if (username.length > USERNAME_MAX_LENGTH) return 'usernameTooLong'
  if (!/^[a-zA-Z0-9._@+-]+$/.test(username)) return 'usernameChars'
  return null
}
